// The Editor's error strings (#797; cross-spec decision D1 on #548): the
// source's `ERRORS`, verbatim and keyed as the source keys them
// (`timmy/src/domains/specifications/islands/SpecEditIsland/constants.ts:3-33`).
// Every Editor surface imports its string from here and never inlines a copy;
// each one reaches the screen through the domain's error snackbar
// (`useSpecErrorSnackbar`).
//
// Two keys are Atlas's own, kept last: `UPDATE_SELECTION_MANUFACTURER` (#803)
// and `RESET_GROUP` (#1084).
//
// Carried whole for completeness: `LOADER` is the edit page's failed-read face
// (#806).
// The drag gesture's one string outside this table — "Moving line to a
// different group is not supported" (`data/actions.ts:114`) — stays with the
// gesture (#800, #809), as the source keeps it.

export const ERRORS = {
  LOADER: "Error loading specification data. Please refresh the page to try again.",
  ADD_GROUP: "Error adding group. Please try again.",
  EDIT_GROUP: "Error updating group. Please try again.",
  MOVE_GROUP: "Error moving group. Please try again.",
  UPDATE_GROUP_STATUS: "Error updating group status. Please try again.",
  DELETE_GROUP: "Error deleting group. Please try again.",
  ADD_LINE: "Error adding line. Please try again.",
  DUPLICATE_LINE: "Error duplicating line. Please try again.",
  CLEAR_LINE: "Error clearing line. Please try again.",
  DELETE_LINE: "Error deleting line. Please try again.",
  RESET_LINE: "Error resetting line. Please try again.",
  MOVE_LINE: "Error moving line. Please try again.",
  UPDATE_LINE_STATUS: "Error updating line status. Please try again.",
  UPDATE_LINE_LOCATION_TYPE: "Error updating line location. Please try again.",
  UPDATE_LINE_LOCATIONS: "Error updating specific locations. Please try again.",
  UPDATE_LINE_DETAILS: "Error updating line details. Please try again.",
  UPDATE_LINE_IS_PER_PLAN: "Error updating line per plan status. Please try again.",
  UPDATE_LINE_IS_PAID_UPGRADE: "Error updating line paid upgrade status. Please try again.",
  EDIT_SPECIFIC_LOCATION_NAME: "Error editing specific location name. Please try again.",
  CREATE_SPECIFIC_LOCATION: "Error creating specific location. Please try again.",
  DELETE_SPECIFIC_LOCATION: "Error deleting specific location. Please try again.",
  UPDATE_LINE_LOCATION_NOTE: "Error updating location note. Please try again.",
  SELECT_ITEM: "Error selecting item. Please try again.",
  REMOVE_SELECTED_ITEM: "Error removing selected item. Please try again.",
  ADD_SELECTION: "Error adding selection. Please try again.",
  CLEAR_SELECTION: "Error clearing selection. Please try again.",
  DELETE_SELECTION: "Error deleting selection. Please try again.",
  RESET_SELECTION: "Error resetting selection. Please try again.",
  UPDATE_SELECTION_DETAILS: "Error updating selection details. Please try again.",
  // Atlas's own, after the source's: the manufacturer save the source only
  // logged to the console (#803; a named parity break, #767 R1). Its sentence
  // takes the table's `Error <verb>ing <thing>.` shape.
  UPDATE_SELECTION_MANUFACTURER: "Error updating manufacturer. Please try again.",
  // Atlas's own: Group Reset is a named scope addition the source has no
  // sentence for (#1060 Q3, Q6; #1084). The table's `Error <verb>ing <thing>.`
  // shape.
  RESET_GROUP: "Error resetting group. Please try again.",
} as const;

export type EditorErrorKey = keyof typeof ERRORS;
